import { render, staticRenderFns } from "./UiTab.vue?vue&type=template&id=0dd51954&scoped=true"
import script from "./UiTab.vue?vue&type=script&lang=js"
export * from "./UiTab.vue?vue&type=script&lang=js"
import style0 from "./UiTab.vue?vue&type=style&index=0&id=0dd51954&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd51954",
  null
  
)

export default component.exports